import SVPShareButton from "Components/Buttons/SVPShareButton";
import React from "react";
import LinkIcon from "@mui/icons-material/Link";
import {DatasetLinked} from "@mui/icons-material";
import {insertNotification} from "Utils/NotificationsUtils";
import PropTypes from "prop-types";

export const AuditShareButton = ({auditID, isLoading = false}) => {
    const handleCopyPublicLink = async () => {
        navigator.clipboard.writeText(window.location.origin + "/public-audits/" + auditID)
            .then(() => {
                insertNotification("Info", "Link copied to clipboard!", "info");
            })
            .catch((err) => {
                console.error("Failed to copy: ", err);
            });
    };

    const handleCopyPrivateLink = async () => {
        navigator.clipboard.writeText(window.location.origin + "/audits/" + auditID + "/?report=false")
            .then(() => {
                insertNotification("Info", "Link copied to clipboard!", "info");
            })
            .catch((err) => {
                console.error("Failed to copy: ", err);
            });
    };

    const shareOptions = [
        {
            onClick: () => handleCopyPublicLink(),
            text: <span style={{color: "green"}}>{<LinkIcon fontSize={"medium"} />} Copy Public Link</span>,
        },
        {
            onClick: () => handleCopyPrivateLink(),
            text: <span style={{color: "red"}}>{<DatasetLinked fontSize={"medium"} />} Copy Private Link</span>,
        },
    ];

    return (
        <SVPShareButton
            options={shareOptions}
            isLoading={isLoading}
        />
    );
};

AuditShareButton.propTypes = {
    auditID: PropTypes.number.isRequired,
    isLoading: PropTypes.bool,
};
